import { getSessionStorageItem, setSessionStorageItem } from "./storage"

export const ERROR_TIMEOUT = 600 // 10 minutes

const key = "nosto:search-templates:error"

export function setErrorSession() {
    const errorTimestamp = getErrorSession()
    const currentTimestamp = getCurrentTimestamp()
    if (!errorTimestamp || currentTimestamp > errorTimestamp) {
        setSessionStorageItem(key, currentTimestamp + ERROR_TIMEOUT)
        return true
    }
    return false
}

function getErrorSession() {
    const errorTimestamp = getSessionStorageItem<number>(key)
    return errorTimestamp ? +errorTimestamp : undefined
}

export function getCurrentTimestamp() {
    return Math.floor(new Date().getTime() / 1000)
}

export function isErrorSession() {
    const errorTimestamp = getErrorSession()
    return errorTimestamp && getCurrentTimestamp() < errorTimestamp
}
